import React, { useState, useEffect } from "react";
import { ThuChiHopDongCombo } from "../../../constants/thuChiHopDongConst";
import userApi from "service/userApi";
import { formatDayMonth } from "utils/formatDate";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import CuaHangDoiTacApi from "service/cuaHangDoiTacApi";
import DoiTinhTrangNoApi from "service/doiTinhTrangNoApi";

export const SearchDesktopXuatHoaDon = ({ dataSearch, onChange, onSearch, isHoaHongTraGop }) => {
  const initKieuVay = [
    { value: "0", label: "Tất cả" },
    { value: "3", label: "Cầm đồ" },
    { value: "1", label: "Tín chấp" },
    { value: "2", label: "Trả góp" },
    { value: "4", label: "Nhận Vay" },
    { value: "5", label: "Bán hàng trả góp" },
  ];
  const [dataKieuVay] = useState(initKieuVay);
  const [nguonkhachhang, setNgonKhachHang] = useState([{ label: "Tất cả", value: 0 }]);
  const [lstTinhTrangNo, setLstTinhTrangNo] = useState([]);
  const [listUser, setListUser] = useState([]);

  useEffect(() => {
    userApi.combo().then((response) => {
      setListUser(response.data.map((item) => ({ value: item.value, label: item.label })));
    });
    CuaHangDoiTacApi.combo().then((response) => {
      setNgonKhachHang(response.data.map((item) => ({ value: item.value, label: item.label })));
    });
    DoiTinhTrangNoApi.getListTinhTrangNo().then((response) => {
      if (response.status === 200) {
        setLstTinhTrangNo([
          { value: "-1", label: "Tất cả" },
          ...response.data.map((item) => ({ value: item.Code, label: item.Name })),
        ]);
      }
    });
  }, []);

  const updateField = (field) => (e) => onChange(field, e.target.value);
  const onChangeDate = (field) => (evt) => onChange(field, formatDayMonth(evt));

  const handleKeyDown = (event) => {
    if (event.key === "Enter") onSearch();
  };

  var tuNgay = currentDate();
  if (dataSearch.tuNgay === "01/01/2001") tuNgay = "";
  else tuNgay = dataSearch.tuNgay;
  var denNgay = currentDate();
  if (dataSearch.denNgay === "01/01/4000") denNgay = "";
  else denNgay = dataSearch.denNgay;
  denNgay = convertDate(denNgay);
  tuNgay = convertDate(tuNgay);

  return (
    <div className="search-new hidden-mobile-main show-table-main">
      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Tìm kiếm</label>
        <input
          type="text"
          className="form-control input-sm"
          placeholder="Mã hợp đồng, tên khách hàng"
          value={dataSearch.ten}
          onChange={updateField("ten")}
          onKeyDown={handleKeyDown}
        />
      </div>
      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Từ ngày</label>
        <DateTimePicker value={tuNgay} onChange={onChangeDate("tuNgay")} placeholder="Từ ngày" name="tuNgay" />
      </div>
      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Đến ngày</label>
        <DateTimePicker value={denNgay} onChange={onChangeDate("denNgay")} placeholder="Đến ngày" name="denNgay" />
      </div>
      {/* <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Nhân viên</label>
        <select name="nhanvien" className="selectBox form-control input-sm" value={dataSearch.nhanvien} onChange={updateField("nhanvien")}>
          {listUser.map((item, idx) => (
            <option key={idx} value={item.value}>{item.label}</option>
          ))}
        </select>
      </div> */}
      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Kiểu vay</label>
        <select name="kieuvay" className="selectBox form-control input-sm" value={dataSearch.kieuvay} onChange={updateField("kieuvay")}>
          {dataKieuVay.map((item, idx) => (
            <option key={idx} value={item.value}>{item.label}</option>
          ))}
        </select>
      </div>
      {/* <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Tình trạng nợ</label>
        <select name="tinhtrangno" className="selectBox form-control input-sm" value={dataSearch.tinhtrangno} onChange={updateField("tinhtrangno")}>
          {lstTinhTrangNo.map((item, idx) => (
            <option key={idx} value={item.value}>{item.label}</option>
          ))}
        </select>
      </div> */}
      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Trạng thái HĐ</label>
        <select name="trangThaiHoaDon" className="selectBox form-control input-sm" value={dataSearch.trangThaiHoaDon} onChange={updateField("trangThaiHoaDon")}>
          <option value={-2}>Tất cả</option>
          <option value={0}>Chờ xuất</option>
          <option value={1}>Đã xuất</option>
          <option value={2}>Bản nháp</option>
          <option value={-1}>Hủy</option>
        </select>
      </div>
      {isHoaHongTraGop && (
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Kênh thanh toán</label>
          <select name="kenhthanhtoan" className="selectBox form-control input-sm" value={dataSearch.kenhthanhtoan} onChange={updateField("kenhthanhtoan")}>
            <option value={"-1"}>Tất cả kênh thanh toán</option>
            {nguonkhachhang.map((item, idx) => (
              <option key={idx} value={item.value}>{item.label}</option>
            ))}
          </select>
        </div>
      )}
      <div className="input-sm-new input-new-18 search-main-new">
        <button type="submit" className="btn btn-info-new btn-seach-ds" onClick={onSearch}>
          <i className="la la-search"></i>
          <span className="search-label"> &nbsp; Tìm kiếm</span>
        </button>
      </div>
    </div>
  );
};
